import { TRANSLATIONS } from '../../translations';

export const getCompanyTypeOptions = () => {
  const companyTypeOptions = {
    individual_company: TRANSLATIONS.INDIVIDUAL_COMPANY,
    company: TRANSLATIONS.COMPANY,
    association: TRANSLATIONS.ASSOCIATION,
  };

  if (freedomeConfig.baseLocale === 'es') {
    companyTypeOptions.foundation = TRANSLATIONS.FOUNDATION;
  }

  return companyTypeOptions;
};
